import { TwitterIcon } from "@/icon/TwitterIcon";
import { Image, Flex, Text, Divider, Spacer, Link, Box, Hide, Show } from "@chakra-ui/react";
import React, { memo } from "react";
export default memo(function BottomComponent() {
   return (
      <>
         <Show above={'BREAK_LPC'}>
            <Image
               alt=""
               w={"100vw"}
               h={"10.1vw"}
               userSelect={"none"}
               src={process.env.REACT_APP_PUBLIC_URL + "images/bottom_new_bg.webp"}
            />
         </Show>
         <Hide above={'BREAK_LPC'}>
            <Image
               alt=""
               w={"100vw"}
               h={{base:'29.74vw',BREAK_LPC:"10.1vw"}}
               userSelect={"none"}
               src={process.env.REACT_APP_PUBLIC_URL + "images/bottom_m_icon.webp"}
            />
         </Hide>
         <Box
            bg="#EFF7FA"
            mt="-2px"
            fontSize={{ base: 14, BREAK_LPC: 16 }}
            pt={{ base: "20px", BREAK_LPC: "24px" }}
            pb={{ base: "34px", BREAK_LPC: "84px" }}>
            <Flex
               flexDir={"column"}
               mx="auto"
               w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}>
               <Image
                  alt="logo"
                  userSelect={"none"}
                  className="refImg"
                  w={"128px"}
                  h={"34px"}
                  data-src={process.env.REACT_APP_PUBLIC_URL + "iconfont/logo_icon.svg"}></Image>
               <Flex flexDir={{ base: "column", BREAK_PAD: "row" }} mt="18px" justifyContent={"space-between"}>
                  <Flex alignItems={"center"} lineHeight={"24px"} fontSize={16}>
                     <Text>© {new Date().getFullYear()} AlohaBots</Text>
                     <Divider
                        borderColor={"#CCC"}
                        orientation="vertical"
                        mx={{ base: "14px", BREAK_LPC: "20px" }}
                        height={{ base: "14px", BREAK_LPC: "20px" }}
                     />
                     <Text>{process.env.REACT_APP_DOMAIN_EMAIL}</Text>
                  </Flex>
                  <Flex mt={{ base: "44px", BREAK_PAD: "0px" }} fontSize={16} alignItems="center">
                     <Link href={"/doc/termsofservice"} isExternal>
                        Terms of Service
                     </Link>
                     <Divider
                        borderColor={"#CCC"}
                        orientation="vertical"
                        h={{ base: "14px", BREAK_LPC: "20px" }}
                        mx={{ base: "14px", BREAK_LPC: "20px" }}
                     />
                     <Link href={"/doc/privacy"} mr={"60px"} isExternal>
                        Privacy Policy
                     </Link>
                     <Spacer />
                     <Link
                        href={process.env.REACT_APP_TWITTER_URL}
                        color={"#333"}
                        _active={{ color: "blue.500" }}
                        _hover={{ color: { base: "#333", BREAK_LPC: "blue.500" } }}
                        isExternal>
                        <TwitterIcon cursor={"pointer"} boxSize={{ base: "24px", BREAK_LPC: "24px" }} />
                     </Link>
                  </Flex>
               </Flex>
            </Flex>
         </Box>
      </>
   );
});
